import React from 'react';
import { SEO } from '../components/SEO';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CheckIcon, ArrowRightIcon, MessageCircleIcon, PenToolIcon, CodeIcon, CheckCircleIcon, ServerIcon, TestTubeIcon, RocketIcon, ShieldIcon, ClockIcon, UsersIcon, TrendingUpIcon, SearchIcon, FileTextIcon, ShoppingCartIcon, LayoutIcon, StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const WebsitesPage: React.FC = () => {
  const websiteTypes = [{
    icon: <FileTextIcon className="h-6 w-6" data-id="element-2427" />,
    title: 'Onepager',
    description: "1–3 pagina's",
    details: 'Professionele website boekhoudkantoor laten bouwen met focus op één duidelijke boodschap'
  }, {
    icon: <LayoutIcon className="h-6 w-6" data-id="element-2428" />,
    title: 'Maatwerk website',
    description: "4+ pagina's",
    details: 'Website ontwerp financieel kantoor met uitgebreide functionaliteit en structuur'
  }, {
    icon: <ShoppingCartIcon className="h-6 w-6" data-id="element-2429" />,
    title: 'Webshop',
    description: 'E-commerce',
    details: 'Complete online verkoopoplossing met betalingen en voorraadbeheer'
  }];
  const benefits = [{
    icon: <CheckCircleIcon className="h-6 w-6" data-id="element-2430" />,
    title: 'Custom webdesign vermogensbeheerder',
    description: 'Volledig op maat gemaakt design dat perfect aansluit bij jouw merkidentiteit en doelgroep.'
  }, {
    icon: <UsersIcon className="h-6 w-6" data-id="element-2431" />,
    title: 'Adviesbureau website laten bouwen',
    description: 'Gespecialiseerd in websites voor adviesbureaus met focus op vertrouwen en expertise.'
  }, {
    icon: <TrendingUpIcon className="h-6 w-6" data-id="element-2432" />,
    title: 'Gebruiksvriendelijk webdesign',
    description: 'Intuïtieve navigatie en heldere structuur voor optimale gebruikerservaring.'
  }, {
    icon: <ShieldIcon className="h-6 w-6" data-id="element-2433" />,
    title: 'Consultancybureau website ontwikkeling',
    description: 'Professionele uitstraling die past bij de financiële sector en jouw expertise.'
  }, {
    icon: <StarIcon className="h-6 w-6" data-id="element-2434" />,
    title: 'Maatwerk website hypotheekadviseur',
    description: 'Specifiek afgestemd op de behoeften van hypotheekadviseurs en hun klanten.'
  }];
  const topCases = [{
    name: 'Wiegers Iconic Nutrition',
    sector: 'E-commerce',
    image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'AS Family Fitness',
    sector: 'Sportschool',
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'metcarla.NL',
    sector: 'Coaching',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }];
  const timelineSteps = [{
    icon: <MessageCircleIcon className="h-6 w-6" data-id="element-2435" />,
    title: 'Intake',
    description: 'We brengen je doelen, doelgroep en wensen helder in kaart via een persoonlijk gesprek.'
  }, {
    icon: <PenToolIcon className="h-6 w-6" data-id="element-2436" />,
    title: 'Ontwerp',
    description: 'We maken een eerste ontwerp dat past bij jouw organisatie en de financiële sector.'
  }, {
    icon: <UsersIcon className="h-6 w-6" data-id="element-2437" />,
    title: 'Afstemmen',
    description: 'Je geeft feedback. Wij verfijnen het ontwerp. Dit herhalen we net zo vaak tot het écht goed voelt.'
  }, {
    icon: <CodeIcon className="h-6 w-6" data-id="element-2438" />,
    title: 'Bouwen',
    description: 'Is het ontwerp akkoord? Dan bouwen we de website technisch op, snel, veilig en schaalbaar.'
  }, {
    icon: <TestTubeIcon className="h-6 w-6" data-id="element-2439" />,
    title: 'Testen & finetunen',
    description: 'Je bekijkt de website en geeft feedback. Wij passen aan tot alles klopt.'
  }, {
    icon: <RocketIcon className="h-6 w-6" data-id="element-2440" />,
    title: 'Oplevering',
    description: 'Bij oplevering geven we live uitleg over hoe je met je website en systemen werkt.'
  }, {
    icon: <ServerIcon className="h-6 w-6" data-id="element-2441" />,
    title: 'Hosting & onderhoud',
    description: 'Na oplevering zorgen wij, indien gewenst, voor hosting, onderhoud en beveiliging.'
  }];
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-2442">
      <SEO title="Maatwerk website administratiekantoor | Noord Digital" description="Maatwerk website administratiekantoor laten maken? Noord Digital bouwt professionele websites voor boekhoudkantoren, consultancybureaus en financieel adviseurs. Vraag een offerte aan." keywords="maatwerk website administratiekantoor, professionele website boekhoudkantoor laten bouwen, consultancybureau website ontwikkeling, maatwerk website hypotheekadviseur, website ontwerp financieel kantoor, custom webdesign vermogensbeheerder, adviesbureau website laten bouwen, gebruiksvriendelijk webdesign, website ontwikkeling consultancy, branchegerichte websiteontwikkeling" canonical="https://noorddigital.nl/website-laten-maken-financieel-adviseur" data-id="element-2443" />
      <Header data-id="element-2444" />

      {/* Hero Section */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#1B2B44] py-16 md:py-20 relative overflow-hidden" data-id="element-2445">
        <div className="absolute inset-0 opacity-20" data-id="element-2446">
          <div className="w-full h-full bg-[url('https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center" data-id="element-2447"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10" data-id="element-2448">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-2449">
            {/* Left side - Main content */}
            <div className="lg:col-span-7" data-id="element-2450">
              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6
            }} className="font-bold text-white leading-tight mb-6 text-4xl md:text-5xl lg:text-6xl" data-id="element-2451">
                Professionele website laten maken voor financieel adviseurs en
                administratiekantoren
              </motion.h1>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} className="text-white text-opacity-90 mb-8 text-lg leading-relaxed" data-id="element-2452">
                Op zoek naar een maatwerk website administratiekantoor die
                perfect aansluit bij jouw dienstverlening? Noord Digital
                specialiseert zich in website ontwikkeling consultancy voor de
                financiële sector. Van professionele website boekhoudkantoor
                laten bouwen tot complete consultancybureau website
                ontwikkeling, wij zorgen voor een website die vertrouwen
                uitstraalt en resultaat oplevert.
              </motion.p>

              {/* Secondary CTA */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="flex flex-wrap gap-4" data-id="element-2453">
                <motion.a href="#keuze" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg hover:bg-gray-100 transition duration-300 shadow-lg group" data-id="element-2454">
                  Bekijk onze opties
                  <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-2455" />
                </motion.a>
              </motion.div>
            </div>

            {/* Right side - Scan CTA Card with Norden badge */}
            <div className="lg:col-span-5" data-id="element-2456">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="bg-white rounded-2xl p-8 shadow-2xl relative" data-id="element-2457">
                {/* Norden badge */}
                <motion.div animate={{
                y: [0, -5, 0]
              }} transition={{
                repeat: Infinity,
                duration: 4,
                ease: 'easeInOut'
              }} className="absolute -top-3 -right-3 w-16 h-16 bg-gradient-to-br from-[#007AFF] to-[#005FCC] rounded-full flex items-center justify-center shadow-lg border-4 border-white" data-id="element-2458">
                  <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="maatwerk website administratiekantoor met Norden" className="w-full h-full object-cover rounded-full" data-id="element-2459" />
                </motion.div>

                <div className="text-center mb-6" data-id="element-2460">
                  <motion.div animate={{
                  scale: [1, 1.05, 1]
                }} transition={{
                  repeat: Infinity,
                  duration: 3,
                  ease: 'easeInOut'
                }} className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#007AFF] to-[#005FCC] rounded-full mb-4 p-2 overflow-hidden" data-id="element-2461">
                    <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden mascotte begeleidt jouw website traject" className="w-full h-full object-cover" data-id="element-2462" />
                  </motion.div>
                  <h3 className="font-bold text-[#111827] text-2xl mb-2" data-id="element-2463">
                    Start de website scan
                  </h3>
                  <p className="text-[#6B7280]" data-id="element-2464">
                    Krijg direct inzicht in wat jouw maatwerk website nodig
                    heeft en welke investering daarbij past
                  </p>
                </div>

                <div className="space-y-3 mb-6" data-id="element-2465">
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  delay: 0.5
                }} className="flex items-center text-sm text-[#6B7280]" data-id="element-2466">
                    <CheckIcon className="h-4 w-4 text-[#007AFF] mr-2 flex-shrink-0" data-id="element-2467" />
                    <span data-id="element-2468">11 korte vragen</span>
                  </motion.div>
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  delay: 0.6
                }} className="flex items-center text-sm text-[#6B7280]" data-id="element-2469">
                    <CheckIcon className="h-4 w-4 text-[#007AFF] mr-2 flex-shrink-0" data-id="element-2470" />
                    <span data-id="element-2471">Direct resultaat</span>
                  </motion.div>
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  delay: 0.7
                }} className="flex items-center text-sm text-[#6B7280]" data-id="element-2472">
                    <CheckIcon className="h-4 w-4 text-[#007AFF] mr-2 flex-shrink-0" data-id="element-2473" />
                    <span data-id="element-2474">Vrijblijvend & kosteloos</span>
                  </motion.div>
                </div>

                <motion.a href="/prijsscan" whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="block w-full bg-[#007AFF] hover:bg-[#005FCC] text-white font-semibold py-4 px-6 rounded-lg transition duration-300 shadow-md hover:shadow-lg text-center group" data-id="element-2475">
                  <span className="flex items-center justify-center" data-id="element-2476">
                    Start de website scan
                    <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-2477" />
                  </span>
                </motion.a>

                <p className="text-xs text-[#6B7280] text-center mt-4" data-id="element-2478">
                  ⏱️ Duurt slechts 2 minuten
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      {/* Website Types Section */}
      <div id="keuze" className="w-full bg-white py-20 md:py-24" data-id="element-2479">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-2480">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2481">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-2482">
              Kies het type website dat bij jou past
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-2483">
              Van een compacte onepager tot een uitgebreide maatwerk website
              administratiekantoor, wij bouwen de oplossing die perfect aansluit
              bij jouw behoeften.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2484">
            {websiteTypes.map((type, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -5,
            borderColor: '#007AFF'
          }} className="bg-[#F7F8FA] rounded-2xl p-8 hover:shadow-lg transition-all duration-300 border-2 border-transparent group" data-id="element-2485">
                <motion.div whileHover={{
              scale: 1.1,
              rotate: 5
            }} className="w-14 h-14 bg-[#007AFF] bg-opacity-10 rounded-full flex items-center justify-center text-[#007AFF] mb-4" data-id="element-2486">
                  {type.icon}
                </motion.div>
                <h3 className="font-bold text-[#111827] text-xl mb-2" data-id="element-2487">
                  {type.title}
                </h3>
                <p className="text-[#007AFF] font-semibold text-sm mb-3" data-id="element-2488">
                  {type.description}
                </p>
                <p className="text-[#6B7280] text-sm leading-relaxed" data-id="element-2489">
                  {type.details}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
      {/* Timeline Workflow Section */}
      <div id="werkwijze" className="w-full bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] py-20 md:py-24" data-id="element-2490">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-2491">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-2492">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-2493">
              Onze werkwijze: duidelijk, persoonlijk en zonder haast
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-2494">
              Bij het maken van een maatwerk website administratiekantoor werken
              we stap voor stap. Ontwerp en afstemmen herhalen we net zo vaak
              tot je volledig tevreden bent.
            </motion.p>
          </div>

          {/* Linear Timeline */}
          <div className="relative max-w-4xl mx-auto" data-id="element-2495">
            {/* Timeline line */}
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-[#007AFF] bg-opacity-20 hidden md:block" data-id="element-2496">
              <motion.div initial={{
              scaleY: 0
            }} whileInView={{
              scaleY: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.5,
              ease: 'easeInOut'
            }} className="w-full bg-[#007AFF] origin-top" style={{
              height: '100%'
            }} data-id="element-2497" />
            </div>

            {/* Timeline steps */}
            <div className="space-y-12" data-id="element-2498">
              {timelineSteps.map((step, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.15
            }} className="relative flex items-center gap-8 md:gap-12" data-id="element-2499">
                  {/* Timeline dot */}
                  <motion.div whileHover={{
                scale: 1.2
              }} className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#007AFF] rounded-full items-center justify-center text-white shadow-lg hidden md:flex z-10" data-id="element-2500">
                    {step.icon}
                  </motion.div>

                  {/* Content - alternating sides on desktop */}
                  <div className={`w-full md:w-5/12 ${index % 2 === 0 ? 'md:ml-auto md:text-left' : 'md:mr-auto md:text-right'}`} data-id="element-2501">
                    <motion.div whileHover={{
                  y: -5,
                  boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
                }} className="bg-white rounded-xl p-6 shadow-md transition-all duration-300" data-id="element-2502">
                      <div className="flex items-center gap-3 mb-3 md:hidden" data-id="element-2503">
                        <div className="w-10 h-10 bg-[#007AFF] rounded-full flex items-center justify-center text-white flex-shrink-0" data-id="element-2504">
                          {step.icon}
                        </div>
                        <h3 className="font-bold text-[#111827] text-lg" data-id="element-2505">
                          {step.title}
                        </h3>
                      </div>
                      <h3 className="font-bold text-[#111827] text-lg mb-2 hidden md:block" data-id="element-2506">
                        {step.title}
                      </h3>
                      <p className="text-[#6B7280] leading-relaxed" data-id="element-2507">
                        {step.description}
                      </p>
                    </motion.div>
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Link to Hosting */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="text-center mt-12" data-id="element-2508">
            <motion.a href="/hosting" whileHover={{
            x: 5
          }} className="inline-flex items-center text-[#007AFF] font-medium hover:underline" data-id="element-2509">
              Bekijk onze hosting en onderhoud
              <ArrowRightIcon className="h-4 w-4 ml-2" data-id="element-2510" />
            </motion.a>
          </motion.div>
        </div>
      </div>
      {/* Why Maatwerk Website Section */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-2511">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-2512">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2513">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-2514">
              Waarom een maatwerk website voor administratiekantoor?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-2515">
              Een maatwerk website administratiekantoor biedt de flexibiliteit
              en professionaliteit die jouw bedrijf nodig heeft. Ontdek waarom
              steeds meer financiële dienstverleners kiezen voor branchegerichte
              websiteontwikkeling.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-2516">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
          }} className="bg-[#F7F8FA] rounded-2xl p-6 transition-all duration-300 group" data-id="element-2517">
                <motion.div whileHover={{
              scale: 1.1,
              rotate: 5
            }} className="w-12 h-12 bg-[#007AFF] bg-opacity-10 rounded-full flex items-center justify-center text-[#007AFF] mb-4" data-id="element-2518">
                  {benefit.icon}
                </motion.div>
                <h3 className="font-bold text-[#111827] text-lg mb-2" data-id="element-2519">
                  {benefit.title}
                </h3>
                <p className="text-[#6B7280] leading-relaxed text-sm" data-id="element-2520">
                  {benefit.description}
                </p>
              </motion.div>)}
          </div>

          {/* Internal links */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] rounded-2xl p-8 max-w-3xl mx-auto" data-id="element-2521">
            <h3 className="font-bold text-[#111827] text-xl mb-4 text-center" data-id="element-2522">
              Complete oplossing voor jouw website
            </h3>
            <p className="text-[#6B7280] text-center mb-6" data-id="element-2523">
              Een professionele website is meer dan alleen design. Ontdek onze
              aanvullende diensten:
            </p>
            <div className="flex flex-wrap gap-4 justify-center" data-id="element-2524">
              <motion.a href="/hosting" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg hover:bg-gray-100 transition duration-300 shadow-sm group" data-id="element-2525">
                Hosting voor bedrijven
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-2526" />
              </motion.a>
              <motion.a href="/seo" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg hover:bg-gray-100 transition duration-300 shadow-sm group" data-id="element-2527">
                SEO optimalisatie
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-2528" />
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
      {/* Norden Guidance Section */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#005FCC] py-20 md:py-24" data-id="element-2529">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-2530">
          <div className="max-w-4xl mx-auto" data-id="element-2531">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl" data-id="element-2532">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-2533">
                {/* Left - Norden visual */}
                <div className="text-center md:text-left" data-id="element-2534">
                  <div className="inline-block relative" data-id="element-2535">
                    <motion.div initial={{
                    opacity: 0,
                    scale: 0.8
                  }} whileInView={{
                    opacity: 1,
                    scale: 1
                  }} viewport={{
                    once: true
                  }} transition={{
                    type: 'spring',
                    stiffness: 100
                  }} className="w-48 h-48 bg-gradient-to-br from-[#007AFF] to-[#005FCC] rounded-full flex items-center justify-center p-4 relative overflow-hidden" data-id="element-2536">
                      <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden begeleidt jouw maatwerk website administratiekantoor traject" className="w-full h-full object-cover" data-id="element-2537" />
                    </motion.div>
                    {/* Floating icons around Norden */}
                    <motion.div animate={{
                    y: [0, -5, 0],
                    rotate: [0, 5, 0]
                  }} transition={{
                    duration: 3,
                    repeat: Infinity,
                    delay: 0
                  }} className="absolute -top-2 -right-2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg" data-id="element-2538">
                      <CheckCircleIcon className="h-6 w-6 text-[#007AFF]" data-id="element-2539" />
                    </motion.div>
                    <motion.div animate={{
                    y: [0, -5, 0],
                    rotate: [0, -5, 0]
                  }} transition={{
                    duration: 4,
                    repeat: Infinity,
                    delay: 1
                  }} className="absolute -bottom-2 -left-2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg" data-id="element-2540">
                      <UsersIcon className="h-6 w-6 text-[#007AFF]" data-id="element-2541" />
                    </motion.div>
                  </div>
                </div>

                {/* Right - Text */}
                <div data-id="element-2542">
                  <motion.h2 initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} className="font-bold text-[#111827] text-3xl mb-4" data-id="element-2543">
                    Norden begeleidt jouw traject
                  </motion.h2>
                  <motion.p initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 0.1
                }} className="text-[#6B7280] text-lg leading-relaxed mb-6" data-id="element-2544">
                    Onze mascotte Norden staat symbool voor hoe wij werken: als
                    team, inclusief mascotte, samen met jou tot het gewenste
                    resultaat. Van eerste gesprek tot oplevering, wij staan
                    naast je en zorgen dat je maatwerk website
                    administratiekantoor precies wordt zoals je het voor ogen
                    hebt.
                  </motion.p>
                  <div className="space-y-3" data-id="element-2545">
                    <motion.div initial={{
                    opacity: 0,
                    x: 20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    delay: 0.2
                  }} className="flex items-center gap-3" data-id="element-2546">
                      <div className="w-6 h-6 bg-[#007AFF] rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2547">
                        <CheckIcon className="h-4 w-4 text-white" data-id="element-2548" />
                      </div>
                      <span className="text-[#6B7280]" data-id="element-2549">
                        Persoonlijke begeleiding door het hele traject
                      </span>
                    </motion.div>
                    <motion.div initial={{
                    opacity: 0,
                    x: 20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    delay: 0.3
                  }} className="flex items-center gap-3" data-id="element-2550">
                      <div className="w-6 h-6 bg-[#007AFF] rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2551">
                        <CheckIcon className="h-4 w-4 text-white" data-id="element-2552" />
                      </div>
                      <span className="text-[#6B7280]" data-id="element-2553">
                        Directe communicatie met het ontwikkelteam
                      </span>
                    </motion.div>
                    <motion.div initial={{
                    opacity: 0,
                    x: 20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    delay: 0.4
                  }} className="flex items-center gap-3" data-id="element-2554">
                      <div className="w-6 h-6 bg-[#007AFF] rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2555">
                        <CheckIcon className="h-4 w-4 text-white" data-id="element-2556" />
                      </div>
                      <span className="text-[#6B7280]" data-id="element-2557">
                        Doorwerken tot je volledig tevreden bent
                      </span>
                    </motion.div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Client Cases Section */}
      <div className="w-full bg-[#F7F8FA] py-20 md:py-24" data-id="element-2558">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-2559">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-2560">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-2561">
              Adviesbureaus die je voorgingen
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-2562">
              Deze ondernemers kozen voor{' '}
              <a href="/portfolio" className="text-[#007AFF] hover:underline font-medium" data-id="element-2563">
                branchegerichte websiteontwikkeling
              </a>{' '}
              bij Noord Digital. Van betere vindbaarheid tot meer
              klantaanvragen, ontdek wat een professionele website kan betekenen
              voor jouw bedrijf. Bekijk{' '}
              <a href="https://wordpress.org" target="_blank" rel="noopener noreferrer" className="text-[#007AFF] hover:underline font-medium" data-id="element-2564">
                waarom WordPress
              </a>{' '}
              de beste keuze is voor zakelijke websites.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2565">
            {topCases.map((clientCase, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -10
          }} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group" data-id="element-2566">
                <div className="relative h-48 overflow-hidden" data-id="element-2567">
                  <motion.img whileHover={{
                scale: 1.1
              }} transition={{
                duration: 0.5
              }} src={clientCase.image} alt={`${clientCase.name}, branchegerichte websiteontwikkeling`} className="w-full h-full object-cover" data-id="element-2568" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" data-id="element-2569"></div>
                  <div className="absolute bottom-4 left-4 right-4" data-id="element-2570">
                    <span className="inline-block bg-[#007AFF] text-white text-xs font-medium px-3 py-1 rounded-full mb-2" data-id="element-2571">
                      {clientCase.sector}
                    </span>
                    <h3 className="text-white font-bold text-lg" data-id="element-2572">
                      {clientCase.name}
                    </h3>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="text-center" data-id="element-2573">
            <motion.a href="/portfolio" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex items-center bg-[#007AFF] hover:bg-[#005FCC] text-white font-semibold py-3 px-8 rounded-lg transition duration-300 shadow-md hover:shadow-lg group" data-id="element-2574">
              Bekijk alle cases
              <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-2575" />
            </motion.a>
          </motion.div>
        </div>
      </div>

      <Footer data-id="element-2576" />
    </div>;
};